import { nanoid } from "nanoid"
import "../style.scss"
import NotificationsByDayDate from "./NotificationsByDayDate"
import NotificationsItem from "./NotificationsItem"

const NotificationsByDay = ({ data }: $TSMigrationFixMe) => {
  return (
    <div
      key={nanoid()}
      className='d-flex flex-column'
    >
      <NotificationsByDayDate date={data.date} />

      <div className='mb-3 mr-4 mt-2'>
        {data.notifications.map((notification: $TSMigrationFixMe) => (
          <NotificationsItem
            key={`notification-${nanoid()}`}
            notification={notification}
          />
        ))}
      </div>
    </div>
  )
}

export default NotificationsByDay
